// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WM5i","footer":"styles_footer__2zIjd","passCodeTooltip":"styles_passCodeTooltip__aUVGT"};